import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MorphingSquare } from './MorphingSquare';

export const RouteLoader: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [loadingDuration, setLoadingDuration] = useState(800);
    const location = useLocation();

    // Detect network speed and adjust loading duration
    useEffect(() => {
        const getNetworkSpeed = () => {
            // @ts-ignore - Check if Network Information API is available
            const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

            if (connection) {
                const effectiveType = connection.effectiveType;

                // Adjust loading time based on network speed
                switch (effectiveType) {
                    case 'slow-2g':
                        return 2000;
                    case '2g':
                        return 1500;
                    case '3g':
                        return 1000;
                    case '4g':
                    default:
                        return 600;
                }
            }

            // Default duration if Network Information API is not available
            return 800;
        };

        setLoadingDuration(getNetworkSpeed());
    }, []);

    const isFirstMount = React.useRef(true);

    // Show loader on route change
    useEffect(() => {
        // Skip loader on initial mount (handled by main Preloader)
        if (isFirstMount.current) {
            isFirstMount.current = false;
            return;
        }

        setIsLoading(true);

        const timer = setTimeout(() => {
            setIsLoading(false);
        }, loadingDuration);

        return () => clearTimeout(timer);
    }, [location.pathname, loadingDuration]);

    return (
        <AnimatePresence>
            {isLoading && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="fixed inset-0 z-[9999] flex items-center justify-center bg-black"
                >
                    <MorphingSquare message="Loading..." messagePlacement="bottom" />
                </motion.div>
            )}
        </AnimatePresence>
    );
};
